import { useFormik } from "formik";
import { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import * as Yup from "yup";

const BannerLinkingModal = ({
  showLinkingModal,
  setShowLinkingModal,
  activeBanner,
  setActiveBanner,
  setIsRMButton,
  entities,
  setEntities,
  getEntitiesData,
}) => {
  const [fetching, setFetching] = useState(false);

  // // // close modal logic
  const handleCloseDetailsModal = () => {
    if (!activeBanner.module_id || !activeBanner.module_type) {
      setIsRMButton(false);
    }
    formik.setFieldValue("module_type", activeBanner.module_type);
    formik.setFieldValue("module_id", activeBanner.module_id);
    setEntities([]);
    setShowLinkingModal(false);
  };

  // // // vaildation schema for FORM
  const linkingValidations = Yup.object().shape({
    module_type: Yup.string().trim().required("Page is required"),
    module_id: Yup.string().trim().required("Entity is required"),
  });

  // // // Formik logic for Form
  const formik = useFormik({
    initialValues: {
      module_type: activeBanner?.module_type || "",
      module_id: activeBanner?.module_id || "",
    },
    enableReinitialize: true,
    validationSchema: linkingValidations,
    onSubmit: async (values) => {
      setActiveBanner((prev) => ({
        ...prev,
        module_type: values.module_type,
        module_id: values.module_id,
      }));
      handleCloseDetailsModal();
    },
  });

  // // // On change Page name
  const handleFetchEntities = async (e) => {
    e.preventDefault();
    setFetching(true);
    formik.setFieldValue("module_type", e.target.value);
    formik.setFieldValue("module_id", "");
    setEntities([]);
    if (e.target.value) {
      if (e.target.value === "charitable-organizations/details") {
        await getEntitiesData("charitable_organization");
      } else {
        await getEntitiesData(e.target.value);
      }
    }
    setFetching(false);
  };

  return (
    <Modal
      show={showLinkingModal}
      onHide={handleCloseDetailsModal}
      backdrop="static"
      size="md"
      centered
    >
      <Modal.Header closeButton className="bg-dark text-light">
        <Modal.Title>Link Button</Modal.Title>
      </Modal.Header>
      <Modal.Body className="bg-dark">
        <div className="col-lg-12 col-md-12 col-sm-12">
          <Form.Group className="mb-3">
            <label className="form-label">Page</label>
            <Form.Select
              type="text"
              className="bg-dark text-light border-light input-placeholder-light form-control"
              value={formik.values.module_type}
              onChange={(e) => {
                handleFetchEntities(e);
              }}
              isInvalid={
                formik.touched.module_type && !!formik.errors.module_type
              }
            >
              <option value="">Select Page</option>
              <option value="games">Games</option>
              <option value="custom">Custom Pages</option>
              <option value="charitable-organizations/details">
                Charitable Organizations
              </option>
            </Form.Select>
            <Form.Control.Feedback type="invalid">
              {formik.errors.module_type}
            </Form.Control.Feedback>
          </Form.Group>
        </div>
        <div className="col-lg-12 col-md-12 col-sm-12">
          <Form.Group className="mb-3">
            <label className="form-label">Entity</label>

            <div className="position-relative">
              <Form.Select
                type="text"
                className="bg-dark text-light border-light input-placeholder-light form-control pe-5"
                {...formik.getFieldProps("module_id")}
                isInvalid={
                  formik.touched.module_id && !!formik.errors.module_id
                }
              >
                <option value="">Select Entity</option>
                {entities?.map((m) => (
                  <option key={m.id} value={m.id}>
                    {m.name || m.title || m.heading}
                  </option>
                ))}
              </Form.Select>

              {fetching && (
                <span
                  className="spinner-border spinner-border-sm text-light position-absolute"
                  style={{
                    top: "18%",
                    right: "7%",
                  }}
                  role="status"
                  aria-hidden="true"
                ></span>
              )}
              <Form.Control.Feedback type="invalid">
                {formik.errors.module_id}
              </Form.Control.Feedback>
            </div>
          </Form.Group>
        </div>
        <div className="container-fluid mt-3">
          <div className="d-flex justify-content-end">
            <Button
              variant="success"
              className="mx-2"
              onClick={() => {
                formik.handleSubmit();
              }}
            >
              Save
            </Button>

            <Button variant="danger" onClick={handleCloseDetailsModal}>
              Cancel
            </Button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default BannerLinkingModal;
